/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEquipmentType.ts                 *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/equipment-type";

export class AutogenModelEquipmentType<RowType extends ModelRow> extends Endpoint<RowType, RowEquipmentTypeFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEquipmentType extends ModelRow<RowEquipmentTypeFields> {
	constructor(values?: Partial<RowEquipmentTypeFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEquipmentTypeFields {
	applies_to: string;
	company_id: string;
	descr: string;
	equip_length: number;
	equip_width: number;
	exchange_type: string;
	fms_length: string;
	fms_type: string;
	id: string;
	picture_resource: string;
	pnn_code_id: string;
	sort_column: string;
	web_order: number;
	payee_id: string;
}

